import { render, staticRenderFns } from "./BatchDetail.vue?vue&type=template&id=7a79cfd6&"
import script from "./BatchDetail.vue?vue&type=script&lang=js&"
export * from "./BatchDetail.vue?vue&type=script&lang=js&"
import style0 from "./BatchDetail.vue?vue&type=style&index=0&id=7a79cfd6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports